import { InfoLeagueProps } from '../leagues.props';
import { JadeiteImperial } from './JadeiteImperial';

export const JadeiteImperialLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_JADEITE_IMPERIAL}`,
  icon: '🟩',
  name: 'Jadeita Imperial',
  description: 'La joya imperial. Gloria eterna.',
  active: false,
  color: '#FFFFFF',
  bgColor: '#00A86B',
  borderColor: '#00A86B',
  path: '/jadeite-imperial',
  page: JadeiteImperial,
};
